export { default } from './resources-list-item.jsx';